import { AGGREGATED_DATA_SERVICE_TOKEN } from './models/data/aggregated-data.interface';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbNavModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomInputTypesDefinitionsService } from './services/configuration/custom-input-types-definitions.service';
import { PcdbDataSelectorComponent } from './components/pcdb-data-selector/pcdb-data-selector.component';
import { SharedModule } from './shared/shared.module';
import { RdSAPLookUpCodesService } from './services/configuration/rdsap-lookup-codes.service';
import { RdsapComponent } from './components/rdsap/rdsap.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RdSAPRoutingModule } from './rdsap-routing.module';
import { FileUploadModule } from 'ng2-file-upload';
import { AggregatedDataService } from '../core-state/services/aggregated-data.service';
import { AppendixComponent } from './components/tabs/renewables/cards/appendix/appendix.component';
import { VentilationSourceComponent } from './components/tabs/ventilation/cards/ventilation-source/ventilation-source.component';
import { SummaryComponent } from './components/tabs/summary/summary.component';
import { RatingsComponent } from './components/tabs/summary/cards/ratings/ratings.component';
import { RecommendationsComponent } from './components/tabs/summary/cards/recommendations/recommendations.component';
import { AddendaComponent } from './components/tabs/summary/cards/addenda/addenda.component';
import { DetailsComponent } from './components/tabs/summary/cards/details/details.component';
import { InfoComponent } from './components/info/info.component';
import { HealthStatusComponent } from './components/health-status/health-status.component';
import { RdsapErrorComponent } from './components/error/rdsap-error.component';
import { ErrorPageComponent } from '../app/error-page/error-page.component';
import { NgTemplateOutlet } from '@angular/common';
import { ToastsContainerComponent } from './components/toast-container/toast-container.component';
import { PcdbManualControlsTableComponent } from './components/pcdb-manual-controls-table/pcdb-manual-controls-table.component';
import { PcdbManualWeatherCompensationComponent } from './components/pcdb-manual-weather-compensation/pcdb-manual-weather-compensation.component';
import { HighlightRequiredDirective } from './directives/highlight-required.directive';
import { SettingsScreenComponent } from './components/settings-screen/settings-screen.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { ReportsScreenComponent } from './components/reports-screen/reports-screen.component';
import { CreateReportComponent } from './components/create-report/create-report.component';

@NgModule({
  declarations: [
    PcdbDataSelectorComponent,
    RdsapComponent,
    AppendixComponent,
    VentilationSourceComponent,
    SummaryComponent,
    RatingsComponent,
    RecommendationsComponent,
    AddendaComponent,
    DetailsComponent,
    InfoComponent,
    HealthStatusComponent,
    RdsapErrorComponent,
    ErrorPageComponent,
    ToastsContainerComponent,
    PcdbManualControlsTableComponent,
    PcdbManualWeatherCompensationComponent,
    HighlightRequiredDirective,
    ReportsScreenComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    FileUploadModule,
    RdSAPRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    NgbNavModule,
    NgbToastModule,
    NgTemplateOutlet,
    WelcomeScreenComponent,
    SettingsScreenComponent,
    CreateReportComponent
  ],
  exports: [
    InfoComponent,
    RdsapErrorComponent,
    ErrorPageComponent,
    ToastsContainerComponent,
    SharedModule
  ],
  providers: [
    CustomInputTypesDefinitionsService,
    RdSAPLookUpCodesService,
    // Provide the aggregated data service using the injection token and the implementation
    { provide: AGGREGATED_DATA_SERVICE_TOKEN, useClass: AggregatedDataService }
  ],
})
export class RdSAPModule { }
